import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Switch, Route, Link, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import PublicRoute from './pages/PublicRoute';
import PrivateRoute from './pages/PrivateRoute';
import DelayedFallback from './components/common/DelayedFallback';
import Loading from './components/common/Loading';
import HomePage from './pages/HomePage';
import Calendar from './pages/Calendar';
import ProfilePage from './pages/ProfilePage';
import MyCourses from './pages/MyCourses';
import NewTicketPage from './pages/TicketPageNew';
import NotificationPage from './pages/NotificationPage';
import StudentHub from './pages/StudentHub';

/** Lazy Loaded Pages */
const LoginPage = lazy(() => import('./pages/LoginPage'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));
const ResetPasswordSet = lazy(() => import('./pages/ResetPasswordSet'));
const StudentVerify = lazy(() => import('./pages/StudentVerify'));
const ViewStudent = lazy(() => import('./pages/ViewStudent'));
const Course = lazy(() => import('./pages/Course'));
const QuizPreview = lazy(() => import('./pages/QuizPreview'));
const VideoAdmin = lazy(() => import('./pages/VideoAdmin'));
const Video = lazy(() => import('./pages/Video'));
const Settings = lazy(() => import('./pages/Settings'));
const Test = lazy(() => import('./pages/Test'));
const MyCourse = lazy(() => import('./pages/MyCourse'));
const MyProgram = lazy(() => import('./pages/MyProgram'));
const NewMyTicketsID = lazy(() => import('./pages/NewTicketPage'));
const AddNewTicketPage = lazy(() => import('./pages/AddNewTicketPage'));
const ExamSummeryPage = lazy(() => import('./pages/ExamSummeryPage'));
const StudentStatus = lazy(() => import('./pages/StudentStatus'));
const ReRegStatus = lazy(() => import('./pages/ReRegStatus'));
const ReRegPMC = lazy(() => import('./pages/ReRegPMC'));
const ExamRegistrationPage = lazy(() => import('./pages/ExamRegistrationPage'));
const ResultWithheld = lazy(() => import('./pages/ResultWithheld'));
const ClassAttendance = lazy(() => import('./pages/ClassAttendance'));
const Article = lazy(() => import('./pages/Article'));
const ComplimentCommentsPage = lazy(() => import('./pages/ComplimentCommentsPage'));
const ReRegistrationPage = lazy(() => import('./pages/ReRegistrationPage'));
const ReRegistrationSchool = lazy(() => import('./pages/ReRegistrationSchool'));
const ExamDetails = lazy(() => import('./pages/ExamDetails'));
const AssignmentPage = lazy(() => import('./pages/AssignmentPage'));
const MyChats = lazy(() => import('./pages/MyChats'));
const NewChat = lazy(() => import('./pages/NewChat'));
const RequiredStudentDetailsPage = lazy(() => import('./pages/RequiredStudentDetailsPage'));
const MyAssessment = lazy(() => import('./pages/MyAssessment'));
const MobileUploadScannerPage = lazy(() => import('./pages/MobileUploadScannerPage'));
const CourseOverview = lazy(() => import('./pages/CourseOverview'));

class App extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expired: false,
        };
        console.warn = () => {};
    }
    componentDidMount() {}

    render() {
        return (
            <Router basename="/">
                <ToastContainer />

                <Suspense
                    fallback={
                        <DelayedFallback>
                            <Loading />
                        </DelayedFallback>
                    }
                >
                    <Switch>
                        <PublicRoute exact path="/" component={LoginPage} />
                        <PublicRoute exact path="/resetPassword" component={ResetPassword} />
                        <PublicRoute exact path="/resetPasswordSet" component={ResetPasswordSet} />
                        <PublicRoute exact path="/verify/:studentId" component={StudentVerify} />
                        <Route exact path="/viewStudent" component={ViewStudent} />
                        <Route exact path="/viewStudent/:email/:password" component={ViewStudent} />
                        <PublicRoute exact path="/courseinfo/:qid/:password" component={Course} />
                        <PublicRoute exact path="/courseinfo/shortcourse/:sid/:password" component={Course} />
                        <PublicRoute exact path="/courseinfo/:qid/subject/:sid/:password" component={Course} />
                        <PublicRoute exact path="/courseinfo/quizinfo/:qid/:password" component={QuizPreview} />
                        <PublicRoute exact path="/videoAdmin/:videoType/:videoId" component={VideoAdmin} />
                        <PrivateRoute exact path="/video/:videoType/:videoId" component={Video} />
                        <PrivateRoute exact path="/settings" component={Settings} />
                        <PrivateRoute path="/student-hub/:tab?/:page?/:type?/:id?" component={StudentHub} />
                        <PrivateRoute exact path="/test" component={Test} />
                        <PrivateRoute exact path="/home" component={HomePage} />
                        <PrivateRoute exact path="/gdc" component={HomePage} />
                        <PrivateRoute exact path="/calendar" component={Calendar} />
                        <PrivateRoute exact path="/profile" component={ProfilePage} />
                        <PrivateRoute exact path="/mycourses" component={MyCourses} />
                        <PrivateRoute exact path="/course/:qid" component={MyCourse} />
                        <PrivateRoute exact path="/mycourses/:qid" component={MyProgram} />
                        <PrivateRoute exact path="/shortCourse/:sid" component={MyCourse} />
                        <PrivateRoute exact path="/course/:qid/subject/:sid" component={MyCourse} />
                        <PrivateRoute exact path="/course/:qid/subject/:sid/assessment/:aid" component={MyCourse} />
                        <PrivateRoute exact path="/myticketsdetail/:ticketId" component={NewMyTicketsID} />
                        <PrivateRoute exact path="/mytickets" component={NewTicketPage} />
                        <PrivateRoute exact path="/addnewticket" component={AddNewTicketPage} />
                        <PrivateRoute exact path="/myticketsnew/:ticketId" component={NewTicketPage} />
                        <PrivateRoute exact path="/myexam" component={ExamSummeryPage} />
                        <PrivateRoute exact path="/status" component={StudentStatus} />
                        <PrivateRoute exact path="/reregStatus" component={ReRegStatus} />
                        <PrivateRoute exact path="/ReRegUpcomming" component={ReRegPMC} />
                        <PrivateRoute exact path="/examregistration" component={ExamRegistrationPage} />
                        <PrivateRoute exact path="/resultWithheld" component={ResultWithheld} />
                        <PrivateRoute exact path="/course/:qid/subject/:sid/attendance" component={ClassAttendance} />
                        <PrivateRoute exact path="/course/:qid/attendance" component={ClassAttendance} />
                        <PrivateRoute exact path="/article/:id" component={Article} />
                        <PrivateRoute exact path="/complimentcomments" component={ComplimentCommentsPage} />
                        <PrivateRoute exact path="/reregistration/:id?" component={ReRegistrationPage} />
                        <PrivateRoute
                            path="/reregistrationSchool/:regid/:qualification_higher_enrolled/:tab?"
                            component={ReRegistrationSchool}
                        />
                        <PrivateRoute
                            // exact
                            path="/mynotifications/:id?"
                            component={NotificationPage}
                        />
                        <PrivateRoute exact path="/myexamdetails/:examid" component={ExamDetails} />
                        <PrivateRoute exact path="/myassignment/:aid" component={AssignmentPage} />
                        <PrivateRoute path="/mychats/:id?" component={MyChats} />
                        <PrivateRoute exact path="/newchat" component={NewChat} />
                        <PrivateRoute exact path="/requiredStudentDetails" component={RequiredStudentDetailsPage} />

                        <PrivateRoute exact path="/myassessments" component={MyAssessment} />
                        <PrivateRoute
                            exact
                            path="/myassessments/:qid/subject/:sid/assessment/:aid"
                            component={MyCourse}
                        />

                        <Route path="/mobileUpload/:securityToken" component={MobileUploadScannerPage} />

                        <Route exact path="/courseOverview/:qid/subject/:sid/:password?" component={CourseOverview} />
                        <Route
                            exact
                            path="/courseOverviews/:qid/subject/:sid/:stdId/:password?"
                            component={CourseOverview}
                        />
                        <Redirect to="/" />
                    </Switch>
                </Suspense>
            </Router>
        );
    }
}

export default App;
